import * as XLSX from 'xlsx';
import { rowsToCsv, triggerDownload } from '@/utils/cbtBulkTemplates';

export type ExemptionTemplateFormat = 'xlsx' | 'csv'

// The header row the bulk-exemption importer (`bulkExemptFromExcel`) reads.
// Laravel Excel's WithHeadingRow maps these to the `matric_no` / `deleted`
// keys the resolver indexes, so they must match exactly:
//   - matric_no — required; the student's matric number.
//   - deleted   — optional; 0 or 1 (1 un-exempts the student); defaults to 0.
export const EXEMPTION_TEMPLATE_HEADER: string[] = ['matric_no', 'deleted'];

// One illustrative row so admins can see the expected layout at a glance.
export const EXEMPTION_TEMPLATE_SAMPLE_ROW: (string | number)[] = ['SCI/2020/001', 0];

export function exemptionTemplateRows(): (string | number)[][] {
  return [EXEMPTION_TEMPLATE_HEADER, EXEMPTION_TEMPLATE_SAMPLE_ROW];
}

/**
 * Generate and download a sample file for the bulk "exempt from Excel" import,
 * entirely client-side. Mirrors the CBT bulk-template generator
 * (`downloadQuestionTemplate`) and reuses its CSV/download primitives. Defaults
 * to `.xlsx`; the importer also accepts `.csv`.
 */
export function downloadExemptionTemplate(format: ExemptionTemplateFormat = 'xlsx'): void {
  const rows = exemptionTemplateRows();
  const baseName = 'exemption_template';

  if (format === 'csv') {
    triggerDownload(new Blob([rowsToCsv(rows)], { type: 'text/csv;charset=utf-8' }), `${baseName}.csv`);
    return;
  }

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.aoa_to_sheet(rows);
  XLSX.utils.book_append_sheet(wb, ws, 'Exemptions');
  const buf = XLSX.write(wb, { type: 'array', bookType: 'xlsx' }) as ArrayBuffer;
  triggerDownload(
    new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
    `${baseName}.xlsx`,
  );
}
